const stickyHeader = {
    header: document.getElementById('header'),
    mainContent: document.getElementById('main-content'),
    lastScrollTop: 0,

    init() {
        this.setClass();
    },

    setClass() {

        document.addEventListener('scroll', (e) => {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > this.lastScrollTop) {
                this.header.classList.remove('up');
                this.header.classList.add('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.add('down');

            } else {
                this.header.classList.add('up');
                this.header.classList.remove('down');
                this.mainContent.classList.add('up');
                this.mainContent.classList.remove('down');
            }
            this.lastScrollTop = st <= 0 ? 0 : st;

            if (window.pageYOffset === 0) {
                this.header.classList.remove('up');
                this.header.classList.remove('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.remove('down');
            }

        })
    },
}

export default stickyHeader;